import { Box, InputAdornment, TextField } from '@mui/material'
import { SearchOMIcon } from '@omnea-app/icons'

type SidebarSearchFieldProps = {
  placeholder: string
  searchQuery: string
  onSearchChange: (value: string) => void
}

export const SidebarSearchField = ({ placeholder, searchQuery, onSearchChange }: SidebarSearchFieldProps) => (
  <Box sx={{ p: 3 }}>
    <TextField
      fullWidth
      placeholder={placeholder}
      value={searchQuery}
      onChange={(e) => onSearchChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchOMIcon size="18px" />
          </InputAdornment>
        ),
      }}
    />
  </Box>
)
